import React from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Outlet } from "react-router-dom";
import { useEmbedMode } from "./EmbedLayout";

// In embed mode the parent EmbedLayout already renders a partner
// branding header; we suppress Navbar/Footer + drop the top margin
// (which existed only to clear a sticky tenant Navbar). Outside the
// iframe, behaviour is byte-for-byte unchanged.
export const GSTLayout = () => {
  const { isEmbed } = useEmbedMode();
  return (
    <div className="flex flex-col min-h-screen">
      {!isEmbed && <Navbar />}

      <main className={isEmbed ? "flex-1 p-6" : "flex-1 mt-20 p-6"}>
        <Outlet />
      </main>
      {!isEmbed && <Footer />}
    </div>
  );
};
